<app-dialog [dialogWithInput]="dialog">
    <app-sale-invoice-save #saleInvoiceSaveComponent
            [hideSaveButton]="true"
            [id]="dialog.input.id" [saleId]="dialog.input.saleId" (entitySavedEvent)="saved($event)">
    </app-sale-invoice-save>
    <app-button dialog-actions label="Générer" fill="solid" color="primary"
                [loading]="saleInvoiceSaveComponent.saveLoading | async"
                (clickEvent)="saleInvoiceSaveComponent.save()"></app-button>
</app-dialog>
